import $ from 'jquery';
import DataTable from 'datatables.net-bs5';

export function extendDataTablesClasses() {
  // Extend DataTables classes
  $.extend( $.fn.dataTable.ext.classes, {
    container: 'dt-container dt-bootstrap5 h-100',
    length: {
      container: 'dt-length',
      select: 'form-select form-select-solid form-select-sm'
    },
    processing: {
      container: 'dt-processing'
    },
    search: {
      container: 'dt-search',
      input: 'form-control form-control-solid form-control-sm'
    },
    paging: {
      active: 'current',
      button: 'dt-paging-button',
      container: 'dt-paging py-0',
      disabled: 'disabled'
    },
  } );

  // Extend Buttons defaults
  $.extend( true, DataTable.Buttons.defaults, {
    dom: {
      collection: {
        container: {
          tag: 'div',
          className: 'dropdown-menu dt-button-collection show',
          content: {
            tag: 'div',
            className: ''
          }
        },
        closeButton: false,
        button: {
          tag: 'a',
          className: 'dt-button dropdown-item',
          active: 'dt-button-active',
          disabled: 'disabled',
          liner: {
            tag: 'span',
            className: ''
          },
          spacer: {
            className: 'divider',
            tag: 'span'
          }
        }
      }
    }
  } );
}
